<template>
    <el-form
        ref="formRef"
        :model="formData"
        :rules="rulesOriginalCar"
        :validate-on-rule-change="false"
        label-position="top"
    >
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item
              prop="actualTakeOverName"
              :label="'提车人姓名' + columnSeparator"
          >
              <el-input
                  v-model="formData.actualTakeOverName"
                  clearable
                  maxlength="20"
                  placeholder="请输入提车人姓名"
              />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              prop="actualTakeOverTel"
              :label="'提车人联系电话' + columnSeparator"
          >
              <el-input
                v-model="formData.actualTakeOverTel"
                clearable
                v-number:phone
                placeholder="请输入提车人联系电话"
              />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item
              prop="takeOverManager"
              :label="'交接车管' + columnSeparator"
          >
              <el-select
                  v-model="formData.takeOverManager"
                  placeholder="请选择交接车管"
                  filterable
                  style="width: 100%"
              >
                  <el-option
                      v-for="item in carTubeList"
                      :label="item.userName"
                      :value="item.id"
                      :key="item.id"
                  />
              </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              prop="displayMile"
              :label="'表显里程' + columnSeparator"
          >
              <el-input
              v-number:km
              v-model="formData.displayMile"
              placeholder="请输入表显里程"
              clearable
              >
              <template slot="append">公里</template>
              </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item
              prop="remainingReserves"
              :label="'剩余电量/油量' + columnSeparator"
          >
              <el-input
                v-model="formData.remainingReserves"
                clearable
                maxlength="20"
                placeholder="请输入剩余电量/油量"
              />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              prop="takeOverTime"
              :label="'交接完成时间' + columnSeparator"
          >
              <el-date-picker
                  v-model="formData.takeOverTime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  type="datetime"
                  placeholder="请选择交接完成时间"
                  clearable
                  :picker-options="takeOverTimeOption"
                  style="width: 100%"
              />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item
              prop="hasKey"
              :label="'车钥匙' + columnSeparator"
          >
              <el-radio-group v-model="formData.hasKey">
                  <el-radio :label="1">有钥匙</el-radio>
                  <el-radio :label="0">无钥匙</el-radio>
              </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
              prop="hasCarLicense"
              :label="'行驶证' + columnSeparator"
          >
              <el-radio-group v-model="formData.hasCarLicense">
              <el-radio :label="1">有行驶证</el-radio>
              <el-radio :label="0">无行驶证</el-radio>
              </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <div class="fileUpload">
            <div class="txt">{{ `验车交接文件照片${columnSeparator}` }}</div>
            <UploadCommon
              :fileList="inspectionAttachment"
              :limit="10"
              :multiple="true"
              :sizeType="4"
              fileTitle="最多可上传10张图片（支持批量添加）"
              fileTitleWidth="240px"
              :isAlone="false"
              commonUpload
              group="vehicle"
              code="vehicle_inspection_file"
            />
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <div class="fileUpload carAboutPhoto">
          <div class="txt">{{ `车况照片${columnSeparator}` }}</div>
          <UploadCommon
            :fileList="photo"
            :limit="photoNumLimit"
            :multiple="true"
            :sizeType="4"
            :fileTitle="`最多可上传${photoNumLimit}张图片（支持批量添加）`"
            fileTitleWidth="240px"
            :isAlone="false"
            :showUploadBtnByLimit="photoNumLimit"
            commonUpload
            group="order"
            code="order_vehicle_pic"
          />
          </div>
        </el-col>
      </el-row>

      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item
            :label="'备注' + columnSeparator"
            class="textare205"
          >
            <el-input
              v-model="formData.remarks"
              type="textarea"
              placeholder="请输入备注"
              maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
</template>

<script setup>
import { ref, computed, watchEffect, nextTick } from 'vue'
import moment from 'moment'
import { getContactNumber } from '@/utils/extendFormVaildate'
import { isIntiger } from '@/utils/validate'
import { getAllEmployeeList } from '@/api/carManage/index.js'
import { useStoreGetters } from '@/store/hooks'

const { userInfo } = useStoreGetters(['userInfo'])

const props = defineProps({
  initData: {
    type: Object,
    default: () => ({}),
  },
  lastTakeOverTime: {
    type: String,
    default: '',
  },
  // 是原车的表单还是现车的表单
  type: {
    type: String,
    default: '',
  },
})


const formRef = ref(null)

const formData = ref({
  actualTakeOverName: '',
  actualTakeOverTel: '',
  takeOverManager: '',
  displayMile: '',
  remainingReserves: '',
  takeOverTime: '',
  hasKey: '',
  hasCarLicense: '',
  remarks: '',
  unableChangeTime: '',
})

// 验车交接文件
const inspectionAttachment = ref([])
// 车辆相关照片-门店上传
const photo = ref([])

const carTubeList = ref([])

const rulesOriginalCar = {
  actualTakeOverName: [
    {
      required: true,
      message: '不能为空',
      trigger: 'blur',
    },
  ],
  actualTakeOverTel: [
    {
      required: true,
      trigger: 'blur',
      validator: getContactNumber,
    },
    {
      min: 11,
      max: 11,
      message: '格式不正确',
      trigger: 'blur',
    },
  ],
  takeOverManager: [
    {
      required: true,
      message: '不能为空',
      trigger: ['blur', 'change'],
    },
  ],
  displayMile: [
    {
      validator: isIntiger,
      trigger: 'blur',
    },
    {
      required: true,
      message: '不能为空',
      trigger: 'blur',
    },
  ],
  remainingReserves: [
    {
      required: true,
      message: '不能为空',
      trigger: 'blur',
    },
  ],
  takeOverTime: [
    {
      required: true,
      message: '不能为空',
      trigger: 'blur',
    },
  ],
  hasKey: [
    {
      required: true,
      message: '请选择',
      trigger: 'change',
    },
  ],
  hasCarLicense: [
    {
      required: true,
      message: '请选择',
      trigger: 'change',
    },
  ],
}

const takeOverTimeOption = computed(() => {
  return {
    disabledDate: (time) => {
      const today = moment().endOf('day')

      // 如果没有 lastTakeOverTime，则禁用今天之后的日期
      if (!props.lastTakeOverTime) {
        return moment(time).isAfter(today)
      }

      // 解析 lastTakeOverTime 字符串为 moment 对象
      const lastTakeOverMoment = moment(props.lastTakeOverTime)

      // 禁用小于等于 lastTakeOverTime 的日期，以及大于今天的日期
      return moment(time).isSameOrBefore(lastTakeOverMoment) || moment(time).isAfter(today)
    },
  }
})

// 原车入库，车况照片限制为80张，新车出库，车况照片限制为20张
const photoNumLimit = computed(() => {
  return props.type === 'originalData' ? 80 : 20
})
const getCarTubeList = async () => {
  const { code, data } = await getAllEmployeeList()
  if (code === 1) {
    carTubeList.value = data
  }
}

getCarTubeList()

// 获取初始数据
watchEffect(() => {
  if (props.initData && Object.keys(props.initData).length > 0) {
    formData.value = props.initData
    Object.keys(formData.value).forEach((key) => {
      if (formData.value[key] === null) {
        formData.value[key] = ''
      }
    })
    // 如果props.initData里的takeOverTime为null，则取当前时间
    if (formData.value.takeOverTime === '' || formData.value.takeOverTime === null) {
      formData.value.takeOverTime = moment().format('YYYY-MM-DD HH:mm:ss')
    }
    if (formData.value.takeOverManager === '' || formData.value.takeOverManager === null) {
      formData.value.takeOverManager = userInfo.id
    }
  }
})

const getFirstErrorElement = () => formRef.value?.$el?.querySelector('.el-form-item.is-error')

const getValidFormData = () => {
  const inspectionAttachmentList = [{
    remark: '',
    urlList: Array.isArray(inspectionAttachment.value)
      ? inspectionAttachment.value.map((imgItem) => imgItem?.url).filter(Boolean)
      : [],
  }]

  const photoList = [{
    remark: '',
    urlList: Array.isArray(photo.value)
      ? photo.value.map((imgItem) => imgItem?.url).filter(Boolean)
      : [],
  }]

  const inspectionAttachmentAllEmpty = inspectionAttachmentList.every((item) =>
    Array.isArray(item.urlList) && item.urlList.length === 0)

  const photoAllEmpty = photoList.every((item) =>
    Array.isArray(item.urlList) && item.urlList.length === 0)

  return {
    ...formData.value,
    id: formData.value.stockId,
    inspectionAttachment: !inspectionAttachmentAllEmpty
      ? JSON.stringify(inspectionAttachmentList) : null,
    photo: !photoAllEmpty ? JSON.stringify(photoList) : null,
    inspectionVideo: null,
  }
}

const validateForm = () => {
  return new Promise((resolve) => {
    formRef.value.validate(async (valid) => {
      if (valid) {
        resolve({
          valid: true,
          data: getValidFormData(),
          errorElement: null,
        })
        return
      }

      await nextTick()
      resolve({
        valid: false,
        data: null,
        errorElement: getFirstErrorElement(),
      })
    })
  })
}

const getFormData = async () => {
  const { valid, data } = await validateForm()
  if (!valid) {
    throw new Error('校验失败')
  }
  return data
}

defineExpose({
  validateForm,
  getFormData,
})

</script>

<style lang="scss" scoped>
.imgList {
  margin-left: 10px;
  .imgList_summay {
    display: flex;
    align-items: flex-start;
  }
}
.upload-image-box {
  display: flex;
  ::v-deep .el-form-item__label {
    width: 140px;
  }
  ::v-deep .el-form-item__content {
    flex: 1
  }
  .fileUpload {
    display: flex;
  }
}
::v-deep .el-form-item .el-form-item__label {
  justify-content: flex-start;
}
.txt {
  margin-bottom: 10px;
  color: #323233;
}
</style>
